import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class RouterActivateService {

  constructor(private session: SessionService, public router: Router) { }

  canActivate(route: any, state: any): Promise<boolean> {

    return  this.session.getSession().then((value) =>
    {
      const access = !!value?.tokens;

      if (!access) {
        this.router.navigate(['/login'],  { queryParams: { previousUrl: state?.url}});
      }
      return access;
    })
    .catch(() => {
      this.router.navigate(['/login']);
      return false;
    });
  }

}

export const RouterActivate: CanActivateFn = (route, state) => {
  return inject(RouterActivateService).canActivate(route, state);
};
